var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-list',{attrs:{"mode":"ios"}},[_c('ion-item',{staticClass:"cursor-pointer",on:{"click":_vm.sendBroadcastMessage}},[_c('ion-label',{attrs:{"color":"dark","mode":"ios"}},[_vm._v(" Send Broadcast Message ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }